mutation CompanyCardCompanyCreate($input: CompanyCardCompanyCreateInput!) {
  companyCardCompanyCreate(input: $input) {
    companyCardCompany {
      apiKey
      cardCompanyId
      _cardCompanyName
    }
  }
}
